export const FourImagesGrid = () => {
  return (
    <div className="mt-10 px-10 md:px-20 ">
      <span className="text-5xl md:text-7xl mb-5 block">PORTFOLIO & WORK</span>
      <div className="flex gap-4 ">
        <img
          className="w-1/2"
          src={"/photos/home/top_left/top_left.jpg"}
          alt="logo"
          loading="lazy"
        />
        <img
          className="w-1/2"
          src={"/photos/home/top_right/top_right.jpg"}
          alt="logo"
          loading="lazy"
        />
      </div>
      <div className="flex gap-4 mt-5">
        <img
          className="w-1/2"
          src={"/photos/home/bottom_left/bottom_left.jpg"}
          alt="logo"
          loading="lazy"
        />
        <img
          className="w-1/2"
          src={"/photos/home/bottom_right/bottom_right.jpg"}
          alt="logo"
          loading="lazy"
        />
      </div>
    </div>
  );
};
